import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import YouTubeIcon from '@mui/icons-material/YouTube';

const MenuData = [
  {
    title: '고객 정보',
    path: '/naver/crm/customer-list',
    Icon: PeopleAltOutlinedIcon,
  },
  {
    title: '게시판 생성',
    path: '/naver/crm/create-board',
    Icon: NoteAddOutlinedIcon,
  },
  {
    title: '신고받은 게시글 & 신고받은 댓글',
    path: '/naver/crm/reported-posts-and-comments',
    Icon: ReportProblemOutlinedIcon,
  },
  {
    title: '게시글 목록 & 댓글 목록',
    path: '/naver/crm/comment-list',
    Icon: ListAltOutlinedIcon,
  },
  {
    title: '유튜브 업로드',
    path: '/naver/crm/youtube-upload',
    Icon: YouTubeIcon,
  },
  {
    title: '배너 설정',
    path: '/naver/crm/banner-settings',
    Icon: ImageOutlinedIcon,
  },
  {
    title: '서비스 프롬프트 관리',
    path: '/naver/crm/service-prompts',
    Icon: MessageOutlinedIcon,
  },
  {
    title: '메뉴 버튼 관리',
    path: '/naver/crm/menu-management',
    Icon: MenuOutlinedIcon,
  },
];

export { MenuData };
